<!-- Footer markup mirrors https://re3.fccenvironment.co.uk -->
<footer class="footer" role="contentinfo">

  <div class="container">
    <div class="row">
      <div class="col-sm-10 col-sm-push-1 col-md-8 col-md-push-2">

        <a href="#top" id="back-to-top" (click)="backToTop($event)"><svg class="icon icon-arrow-up" aria-hidden="true"><use xlink:href="#icon-arrow-up"/></svg><div class="arrow-label">Back to top</div></a>

        <p class="copyright">
          &copy; {{ year }}

          FCC Recycling (UK) Limited, trading&nbsp;as FCC&nbsp;Environment<br>
          Registered Office:<br>
          3&nbsp;Sidings&nbsp;Court, White&nbsp;Rose&nbsp;Way, Doncaster.&nbsp;DN4&nbsp;5NU<br>
        </p>
        <p>
          Registered&nbsp;in England&nbsp;and&nbsp;Wales No.&nbsp;2674166 VAT&nbsp;reg:&nbsp;No.&nbsp;637&nbsp;8808&nbsp;92
        </p>
        <p>
          <a href="https://www.fccenvironment.co.uk/about-us/policies-and-certificates/privacy-policy/" target="_blank" rel="noopener">Privacy policy</a>
          |
          <a href="https://re3.fccenvironment.co.uk/cookie-policy/" target="_blank" rel="noopener">Cookies</a>
        </p>

      </div>
    </div>
  </div>

</footer>
